import { Injectable } from '@angular/core';
import { ILogService } from './ilog.service';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable()
export class LogService implements ILogService {
  private _verboseLogging: boolean;
  private _localStorageService: LocalStorageService;
  private _wlVerboseLoggingKey: string = 'wl-verbose-logging';

  public constructor(localStorageService: LocalStorageService) {
    this._localStorageService = localStorageService;

    if (this._localStorageService.getBoolean(this._wlVerboseLoggingKey) == true) {
      this._verboseLogging = true;
    } else if (window.location.host.toLowerCase().indexOf('localhost') >= 0) {
      this._verboseLogging = false;
    } else {
      this._verboseLogging = false;
    }
  }

  public log = (title: string, entry: string): void => {
    if (this._verboseLogging == true) {
      console.log(title, entry);
    }
  };

  /**
   * Always writes, and never throws.
   *
   * Added for ATLAS-5608. The two existing methods cannot express "an expected
   * failure the operator must be able to see": `log` is suppressed unless the
   * `wl-verbose-logging` flag is set, which it is not in any environment by
   * default, and `error` throws its argument, so a caller reporting a handled
   * outcome would turn it into an unhandled one.
   *
   * That gap made a tenant-mismatch rejection — the event the tenant-switch fix
   * exists to produce — invisible in production. Use this for outcomes that are
   * expected, handled, and still worth an operator seeing; keep `error` for
   * genuinely unexpected failures a caller intends to propagate.
   */
  public warn = (title: string, entry: string): void => {
    console.warn(title, entry);
  };

public error = (entry: any): void => {
    console.error(entry);
    throw entry;
};


  public enableVerboseLogging = (): void => {
    this._localStorageService.setBoolean(this._wlVerboseLoggingKey, true);
    this._verboseLogging = true;
  };

  public disableVerboseLogging = (): void => {
    this._localStorageService.setBoolean(this._wlVerboseLoggingKey, false);
    this._verboseLogging = false;
  };

  public VerboseLogging = (): boolean => {
    return this._verboseLogging;
  };
}
